import { render, staticRenderFns } from "./DesignUpload.vue?vue&type=template&id=2bf88916&"
import script from "./DesignUpload.vue?vue&type=script&lang=js&"
export * from "./DesignUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports